import React, { Suspense, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LoaderContext } from "../../../../../Services/Loader_Provider_Service/LoadingContext";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getOnlineTraining } from "../../Services/SelfLearning";
import AddCourseToWishlist from "../AddCourseToWishlist/AddCourseToWishlist";
import { RadioButton } from 'primereact/radiobutton';
const ComponentLoader = React.lazy(() => import("../../../../../Shared/Sidebar/ComponentLoader"));
function QuizDetail() {
    let userDetails = JSON.parse(localStorage.getItem("User") || '');
    const [courses, setCourses] = useState([]);
    const [questionList, setQuestionList] = useState([]);
    const [Isloading, setIsloading] = useState(false);
    const { showLoading, hideLoading } = useContext(LoaderContext);
    const { CourseId } = useParams();
    const { ModuleId } = useParams();
    useEffect(() => {
        GetOnlineTraining();
    }, [])
    async function GetOnlineTraining() {
        setIsloading(true)
        let body = {
            "AccountId": userDetails?.OrgId,
            "LoggedInUserId": userDetails?.EmpId,
            "UserId": 0,
            "CourseId": Number(CourseId),
            "Search": "",
            "PageNumber": 1,
            "CategoryId": 0,
            "PageSize": 100,
            "NewOnly": 0,
            "BookmarkedOnly": 0,
            "FreeOnly": 0,
            "MyCourse": 0
        }
        try {
            let response = await getOnlineTraining(body);
            setCourses(response?.Data?.courses[0])
            setQuestionList(response.Data.courses[0]?.lstModules?.filter((lstModule) => { return lstModule.Id == ModuleId })?.[0]);//lstQuizQuestion
            setIsloading(false)
        } catch (err) {
            setIsloading(false)
        }
    }

    useEffect(() => {
    },[questionList]);

    return (
        <div className="position-relation">
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn" >
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>
                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>

            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">

                <div className="row">
                    <div className="col-xl-8">
                        <div className="col-xl-12">
                            <div className="card position-rel">
                                <div className="card-body">
                                    <div className="block-header more-padding">
                                        <div className="coursedetail">
                                            <div className="des">
                                                <h4 className="block-heading">{courses?.CourseTitle}</h4>
                                                <p className="block-text  mb-0">{courses?.CourseContent}</p>
                                            </div>
                                            <Link className="add-more" to={`/SelfLearningDashboard/CourseDetails/${CourseId}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                    fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
                                                  16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
                                                  07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
                                                  .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <img className="avatar position-ab" src="/images/org-img//learn/coursepng.png" alt="" />
                            </div>

                        </div>
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="" id="quizzes">
                                        <div className="">
                                            <ul className="rate">
                                                {questionList?.lstQuizQuestion?.map((question, index) =>
                                                    question?.lstQuestionOptions?.map((option) =>
                                                        option?.IsCorrectId === true && option?.Answerid === option?.Id ? <li className="check" style={{ backgroundColor: 'green' }}><span>{index + 1}</span></li>
                                                            : option?.IsCorrectId === true ?
                                                                <li style={{ backgroundColor: 'red' }}><span>{index + 1}</span></li> : ''
                                                    )
                                                )}
                                            </ul>
                                            {questionList?.lstQuizQuestion?.map((question, index) =>
                                                <div className="detail">
                                                    <span>{index + 1}</span>
                                                    <h3>{question?.QuestionText}</h3>
                                                    {question?.lstQuestionOptions?.map((option, OptionIndex) =>
                                                        <div className="question">
                                                            <strong>{String.fromCharCode(65 + OptionIndex)}.  {option?.Options}</strong>
                                                            {option?.IsCorrectId === true && option?.Answerid === option?.Id ?

                                                                <div> <span style={{ backgroundColor: 'green' }} >You Answered Correctly</span>
                                                                    <RadioButton inputId={OptionIndex.key} name="category" value={option?.Options} checked={true} /></div>
                                                                :
                                                                option?.IsCorrectId === true
                                                                    ?
                                                                    <div>  <span style={{ backgroundColor: 'green' }}>Correct Answer</span>
                                                                        <RadioButton inputId={OptionIndex.key} name="category" value={option?.Options} checked={option?.IsCorrectId} /></div>
                                                                    :
                                                                    option?.Answerid === option?.Id
                                                                        ?
                                                                        <div><span style={{ backgroundColor: 'red' }}>You Answered</span>
                                                                            <RadioButton inputId={OptionIndex.key} name="category" value={option?.Options} checked={option?.Answerid === option?.Id} /></div>
                                                                        :
                                                                        <RadioButton inputId={OptionIndex.key} name="category" value={option?.Options} checked={false} />}

                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div></div></div>
                        </div>
                    </div>

                    <div className="col-xl-4">
                        <AddCourseToWishlist courseDetails={courses} />
                    </div>
                </div>

            </div>
            <div className="modal fade" id="view-score">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content text-center">
                        <div className="modal-header d-block text-center">
                            <h5 className="modal-title m-auto">Result Score</h5>
                            <p className="mb-0">Last updated today 09.25</p>
                        </div>
                        <div className="progress blue">
                            <span className="progress-left">
                                <span className="progress-bar"></span>
                            </span>
                            <span className="progress-right">
                                <span className="progress-bar"></span>
                            </span>
                            <div className="progress-value">90%

                            </div>
                        </div>
                        <span>Out of 100</span>
                        <strong>Very good!</strong>
                        <p>Your score is in warm up model</p>
                        <div className="modal-footer m-auto">
                            <Link to={`/SelfLearningDashboard/CourseDetails/QuizDetails/QuizResult/${CourseId}`}><i className="fa fa-angle-right" aria-hidden="true" data-bs-toggle="modal"
                                data-bs-target="#viewquizzes" data-dismiss="modal"></i></Link>
                        </div>
                        <p>View Questions</p>
                    </div>
                </div>
            </div>
            {
                Isloading ? <Suspense >
                <ComponentLoader />
            </Suspense> : ''
            }
        </div>
    )
}
export default QuizDetail;